'use strict';
import * as T from 'prop-types';


export const DateLabel = {
  /** @type {DateLabel} */
  byLabel: 'byLabel',
  /** @type {DateLabel} */
  atLabel: 'atLabel',
};

export const isDateLabel = T.oneOf(Object.values(DateLabel));

/**
 * @typedef {String} DateLabel
 */



// WEBPACK FOOTER //
// ./src/js/tasks/enums/DateLabel.js